import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import styled from 'styled-components';

export const AutoCompleteContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: nowrap;
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    width: 100%;
    height: auto;
    max-height: 240%;
    overflow-y: auto;
    overflow-x: hidden;
    background: ${COLORS.white};
    border: solid 1px ${COLORS.grey};
    border-radius: ${BorderRadius.componentRadius};
    visibility: ${props => (props.show ? 'visible' : 'hidden')};
    z-index: 10;
`;

export const AutoCompleteItem = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    flex-shrink: 0;
    width: 100%;
    height: 30px;
    padding: 8px 13px;
    cursor: pointer;
    color: ${props => props.focused ? COLORS.TextWhite : COLORS.TextPrimary};
    background: ${props => (props.focused ? COLORS.Control : COLORS.BgMain)};

    &:hover {
        background: ${props => !props.focused && COLORS.lightGrey};
    }
`;
